import { InjectionToken } from '@angular/core';

export const FinancialClassifications = [
  {
    code: 'CS',
    description: 'Micro Enterprise',
  },
  {
    code: 'CE',
    description: 'CommSME less GBP6.5m',
  },
  {
    code: 'RP',
    description: 'Consumer',
  },
  {
    code: 'CO',
    description: 'Other Comm',
  },
  {
    code: 'LA',
    description: 'Lge Comm UK',
  },
  {
    code: 'LE',
    description: 'Lge Comm EEA',
  },
  {
    code: 'LU',
    description: 'Lge Comm nonUKEEA',
  },
  {
    code: 'OE',
    description: 'Other Comm EEA',
  },
  {
    code: 'OC',
    description: 'Other Comm nonUKEEA',
  },
  {
    code: 'CL',
    description: 'LC Inside EEA',
  },
  {
    code: 'CU',
    description: 'SC UK',
  },
  {
    code: 'CX',
    description: 'SC Outside UK & EEA',
  },
  {
    code: 'CZ',
    description: 'LC Outside EEA',
  },
  {
    code: 'EB',
    description: 'Exempt Business',
  },
] as const;

export const ENABLE_FCA_CLASSIFICATION = new InjectionToken<boolean>(
  'Enable or disable FCA classification'
);
